import { useTheme } from "@mui/material";
import { TierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/TierCardWrapper";
import { TIERS_CARD_IMAGE_SIZE } from "@src/appV2/redesign/Tiers/utils/constants";
// eslint-disable-next-line no-restricted-imports
import SilverStarBadge from "@src/assets/images/silverStarBadge.png";

export function SilverTierCardWrapper(props: { children: React.ReactNode }) {
  const { children } = props;
  const theme = useTheme();

  return (
    <TierCardWrapper
      image={SilverStarBadge}
      imageSize={TIERS_CARD_IMAGE_SIZE}
      background={theme.palette.tiers?.silver?.background}
    >
      {children}
    </TierCardWrapper>
  );
}
